module.exports = __webpack_public_path__ + "static/img/logo_rio.de3befe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_rio.png
// module id = eeMT
// module chunks = 4